import { Location } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { BreadcrumbsComponent } from 'components/breadcrumbs/breadcrumbs.component';
import { ConfirmModalComponent } from 'components/modal/confirm-modal/confirm-modal.component';
import { SpinnerComponent } from 'components/spinner/spinner.component';
import { OrganizationGeneralInfoFormComponent } from 'components/organization-sections/organization-general-info-form/organization-general-info-form.component';
import { ApiService } from 'services/api.service';
import { Breadcrumb } from 'types/breadcrumb.interface';
import { CountryDto, CountryDtoPagedResult } from 'types/country.interface';
import { LegalEntityCard } from 'types/legal-entity.interface';

@Component({
  selector: 'app-add-organization-page',
  standalone: true,
  imports: [BreadcrumbsComponent, TranslateModule, SpinnerComponent, OrganizationGeneralInfoFormComponent, ConfirmModalComponent],
  templateUrl: './add-organization-page.component.html',
  styleUrl: './add-organization-page.component.scss'
})
export class AddOrganizationPageComponent implements OnInit {
  @ViewChild(OrganizationGeneralInfoFormComponent) formComponent!: OrganizationGeneralInfoFormComponent;
  confirmModalOpen: boolean = false;

  breadcrumbs: Breadcrumb[] = [
    { title: 'components.breadcrumbs.organizationList', url: '/klienti/juridiskas-personas' },
    { title: 'components.breadcrumbs.addOrganization', url: '/klienti/pievienot-juridisku-personu' }
  ];

  isLoading: boolean = true;
  countries: CountryDto[] = [];

  constructor(
    private apiService: ApiService,
    private router: Router,
    private location: Location
  ) {}

  ngOnInit(): void {
    this.apiService.getCountries().subscribe((countries: CountryDtoPagedResult) => {
      this.countries =
        countries.list?.sort((a, b) => {
          if (a.code === 'LV') return -1;
          if (b.code === 'LV') return 1;
          return (a.name ?? '').localeCompare(b.name ?? '', 'lv');
        }) ?? [];
      this.isLoading = false;
    });
  }

  submit(): void {
    this.formComponent.submit();
  }

  onLegalEntityCreated(legalEntity: LegalEntityCard): void {
    this.router.navigate(['/juridiska-persona', legalEntity.id]);
  }

  back(): void {
    if (this.formComponent?.form?.dirty) {
      this.confirmModalOpen = true;
    } else {
      this.location.back();
    }
  }

  confirmBack(): void {
    this.confirmModalOpen = false;
    this.location.back();
  }
}
